import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { usePageTitle, FAQS } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";

export default function Faq() {
  usePageTitle(
    "FAQ — Sitebound Construction Job Seeker Packs",
    "Answers about Sitebound digital packs: instant download delivery, what's included, White Card and tickets guidance, FIFO, refunds and more."
  );
  return (
    <div data-testid="faq-page" className="mx-auto max-w-4xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
      <Reveal>
        <div className="mono-label">Support</div>
        <h1 className="font-display mt-4 text-5xl font-extrabold uppercase tracking-tight text-slate-100 sm:text-6xl">
          Frequently asked questions
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-400">
          Everything about digital delivery, what's in the packs, Australian tickets and licences,
          FIFO work and refunds.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-white/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-sm font-semibold uppercase tracking-wide text-slate-200 hover:text-[#FF5500] hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-slate-400">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  );
}
